import Swiper from "swiper/bundle";
import 'swiper/css/bundle';

export default function MembersSlider() {
    return {
        swiperInstance: null,
        init() {
            this.swiperInstance = new Swiper('.slider-members', {
                slidesPerView: 1,
                navigation: {
                    nextEl: '.member-next',
                    prevEl: '.member-prev',
                },
                pagination: {
                    el: '.member-pagination',
                    clickable: true,
                },
                spaceBetween: 30,
            });
        }
    }
}